export default __webpack_public_path__ + "static/media/logo-b.d0272a16.png";